import script from "./rechargePoints.vue?vue&type=script&setup=true&lang=ts"
export * from "./rechargePoints.vue?vue&type=script&setup=true&lang=ts"

import "./rechargePoints.vue?vue&type=style&index=0&id=c64d1e54&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c64d1e54"]])

export default __exports__